declare global {
  interface IWindow {
    AltenarCore: any,
    preloadAltenarWidget: any,
    deleteAltenarWidget: any
  }
}


__webpack_public_path__ = ''
const windowProxyObject = (window as unknown) as IWindow

export { windowProxyObject }

